export enum ACCOUNT_INFORMATION {
  EMAIL = 'emailAddress',
  NAME = 'name',
  COUNTRY = 'country',
  MSISDN = 'msisdn',
  CALLBACK = 'callback'
}

export enum OTP_VERIFICATION {
  EMAIL = 'emailOtp',
  SMS = 'smsOtp'
}
